import { bestaetigen } from "../redesign/bestaetigen";

/**
 * Rückfrage, bevor MEHRERE Notizen auf einmal gelöscht werden (eine einzelne,
 * auch fremde, geht ohne)
 * (`NotizFeld.bestaetigeLoeschen`) — gemeinsam für Vorgang und Kundentagebuch.
 * Eine gelöschte Notiz lässt sich in der Oberfläche nicht wiederherstellen.
 */
export function bestaetigeNotizenLoeschen(anzahl: number, fremde: number): Promise<boolean> {
    const titel = anzahl === 1 ? "Notiz löschen?" : `${anzahl} Notizen löschen?`;
    const text =
        fremde > 0
            ? `${anzahl === 1 ? "Diese Notiz stammt" : `${anzahl} Notizen, davon ${fremde} von Kolleginnen oder Kollegen, stammen`} nicht von dir. Das Löschen lässt sich nicht rückgängig machen.`
            : "Das Löschen lässt sich nicht rückgängig machen.";
    return bestaetigen({ titel, text, ja: "Löschen", ton: "danger" });
}
